import {Component, OnDestroy, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';

import * as fromApp from '../../store/app.reducers';
import * as fromUser from '../store/user.reducers';
import * as UserActions from '../store/user.actions';
import * as fromTrial from '../../profile/trial/store/trial.reducers';
import {Cookie} from '../../helper/cookie';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-user-edit-type',
    templateUrl: './user-edit-type.component.html',
    styleUrls: ['./user-edit-type.component.scss'],
    standalone: false
})
export class UserEditTypeComponent implements OnInit, OnDestroy {

  cookies: Cookie;
  type: number;
  trialSubscription: Subscription;
  steps: any;

  constructor(
    public store: Store<fromApp.AppState>
  ) {
    this.cookies = new Cookie();
  }

  ngOnInit() {
    this.trialSubscription = this.store.select('trial').subscribe(
      (state: fromTrial.State) => {
        this.steps = state.steps;
      }
    );
  }

  setType(type: number) {
    this.type = type;
    const version = +this.cookies.getCookie('auditor-version');
    let url = ['/audits'];
    if (version === 4) {
      url = this.steps.audit.url;
    }

    if (version === 3) {
      url = this.steps.audit.url;
    }

    this.store.dispatch(
      new UserActions.ChangeUser({
        id: +this.cookies.getCookie('auditor-user-id'),
        params: {
          type: type
        },
        config: {
          redirectAfterSave: true,
          redirectUrl: url
        }
      })
    );
  }

  ngOnDestroy() {
    this.trialSubscription.unsubscribe();
  }

}
